export const RESET_CURRENT_CAMPAIGN = 'RESET_CURRENT_CAMPAIGN'
export const RESET_CAMPAIGNS = 'RESET_CAMPAIGNS'
export const RESET_ORG_STATE = 'RESET_ORG_STATE'
export const RESET_ORG_CURRENT = 'RESET_ORG_CURRENT'
export const RESET_USER_STATE = 'RESET_USER_STATE'
export const RESET_SDB_STATE = 'RESET_SDB_STATE'
export const RESET_FILE_STATE = 'RESET_FILE_STATE'

export const LIST_CAMPAIGNS = 'LIST_CAMPAIGNS'
export const LIST_CAMPAIGNS_SUCCEEDED = 'LIST_CAMPAIGNS_SUCCEEDED'
export const LIST_CAMPAIGNS_FAILED = 'LIST_CAMPAIGNS_FAILED'

export const SET_CAMPAIGN_PLAN = 'SET_CAMPAIGN_PLAN'

export const SET_DIALPLAN_FROM_STEP = 'SET_DIALPLAN_FROM_STEP'
export const RESET_DIALPLAN_STATE = 'RESET_DIALPLAN_STATE'
export const SET_DIALPLAN_CURRENT_STEP = 'SET_DIALPLAN_CURRENT_STEP'
export const SET_DIALPLAN_NEXT_STEP = 'SET_DIALPLAN_NEXT_STEP'
export const SET_DIALPLAN_INPUT = 'SET_DIALPLAN_INPUT'
export const UPDATE_DIALPLAN_TREE = 'UPDATE_DIALPLAN_TREE'

export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'
export const RESET_CURRENT_USER_LOADING = 'RESET_CURRENT_USER_LOADING'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_CURRENT_LOGO = 'SET_CURRENT_LOGO'
export const SET_GLOBAL_LOGO = 'SET_GLOBAL_LOGO'
export const SET_GLOBAL_TITLE = 'SET_GLOBAL_TITLE'

export const SET_CURRENT_TITLE = 'SET_CURRENT_TITLE'
export const SET_CURRENT_USER_ORGID = 'SET_CURRENT_USER_ORGID'
export const SET_USER_ROLES = 'TRANSFORM_USER_ROLES'
export const RESET_USER_CURRENT = 'RESET_USER_CURRENT'
export const SET_ROLES = 'SET_ROLES'
export const TMP = 'TMP'
export const SET_CURRENT_CAMPAIGN = 'SET_CURRENT_CAMPAIGN'
export const SET_DUPLICATE_CAMPAIGN = 'SET_DUPLICATE_CAMPAIGN'
export const SET_DB_VARIABLES = 'SET_DB_VARIABLES'

export const RESET_TOUR_STATE = 'RESET_TOUR_STATE'
export const UPDATE_CURRENT_TOUR = 'UPDATE_CURRENT_TOUR'
export const CHANGE_ACTIVE_HELP = 'CHANGE_ACTIVE_HELP'
export const UPDATE_CURRENT_TOUR_DATA = 'UPDATE_CURRENT_TOUR_DATA'
export const SET_VIEWED_VALUE = 'SET_VIEWED_VALUE'

export const ADD_AUDIO_FILE = 'ADD_AUDIO_FILE'
export const REMOVE_AUDIO_FILE = 'REMOVE_AUDIO_FILE'
export const SET_AUDIO_FILES = 'SET_AUDIO_FILES'
export const SET_AUDIO_FILES_ADDED = 'SET_AUDIO_FILES_ADDED'
export const RESET_AUDIO_FILES = 'RESET_AUDIO_FILES'
export const SET_AUDIO_FILES_LOADING = 'SET_AUDIO_FILES_LOADING'
export const SET_AUDIO_FILES_ERROR = 'SET_AUDIO_FILES_ERROR'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js